import gql from 'graphql-tag';

export const GetAnnotationByIdQuery = gql`
  query GetAnnotationByIdQuery($id: String){
    annotation(id: $id) {
      id
      fileName
      fileSize
      mimeType
      documentBody
    }
  }
`;